<template>
  <div>
    <!-- <el-row class="container" v-loading="loading">     
      <el-button @click="search" type="success" >
        <strong class="white">Search</strong>
      </el-button>
    </el-row>
    -->
    <br>
    <el-row class="container">
      <el-table
        :data="viewVacationSubmitted"
        :row-class-name="vacationStatus1"
        :default-sort="{prop: 'decision', order: 'ascending'}"
        :header-cell-style="{background:'rgb(170, 238, 238)',color:'black', 'text-align':'center'}"
        border
      >
        <!--:formatter="getName" prop="leave_on"-->

        <el-table-column label="Name" sortable :formatter="getName" width="190px" align="center" :sort-method="(a, b) => sortName(a, b)"></el-table-column>
        <el-table-column
          prop="total_days_req"
          sortable
          label="Total days requested" 
          width="100px"
          align="center" :sort-method="(a, b) => sorttotalDateRequestedDate(a, b)"
        ></el-table-column>
        <el-table-column sortable :formatter="getleaveon" label="Leave on"  width="130px" align="center" :sort-method="(a, b) => sortDate(a, b)"></el-table-column>
        <el-table-column sortable :formatter="getleaveend" label="Leave end"  width="130px" align="center" :sort-method="(a, b) => sortDatesortDateLeaveEnd(a, b)"  ></el-table-column>
        <el-table-column sortable :formatter="getreturnon" label="Return on"  width="130px" align="center" :sort-method="(a, b) => sortDatesortDateReturnOn(a, b)" ></el-table-column>
        <el-table-column sortable :formatter="getTypeOfvacation" label="Type"  width="120px" align="center" :sort-method="(a, b) => sortTypeOfvacation(a, b)"></el-table-column>
        <el-table-column sortable label="Status" :formatter="getStatus" width="100px"  align="center" :sort-method="(a, b) => sortStatus(a, b)"></el-table-column>
        <!--:formatter="getTypeOfvacation" -->
        <el-table-column label="Actions" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="userlevel<2"
              type="primary"
              @click="Edit(scope.$index, scope.row)"
              icon="el-icon-edit"
              circle
            ></el-button>
            <el-button
              v-if="userlevel<2"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="open(scope.$index, scope.row)"
            ></el-button>
            <el-button
              v-if="userlevel<2"
              type="warning"
              icon="el-icon-printer"
              circle
              @click="exportVacation(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { personnel } from "../../api/personnel/personnel";
import { vacation } from "../../api/vacation";
import Moment from "moment";
import Component from "vue-class-component";
import { postgrest } from "../../api/postgrest";

@Component({
  name: "ViewVacationSubmitted"
})
export default class ViewVacationSubmitted extends Vue {
  public viewVacationSubmitted: any[] = [];
  public viewVacationSubmitted1: any[] = [];
  public personnelList: any[] = [];
  public TypeofvacationList: any[] = [];
  public loading: boolean = true;
  public userlevel: number = -1;
  public statusofvacation: number = 1;
  public statusofvacationList: any[] = [];
  public id1: number = -1;
  public year1: any = "";
  public nameAsc:boolean = false;
  public dateAsc:boolean = false;

  /*
public async search() {
await this.getvacationList();

}
*/
  public async created() {
    this.loading = true;
    let object = this.$store.getters.getCurrentObject;

    this.year1 = object.year;

    if (object.id != undefined) this.id1 = object.id.id;

    this.$store.dispatch("updateCurrentObject", {
      year: undefined,
      id: undefined
    });

    await this.getPersonnelList();
    await this.getvacationList();
    await this.getTypeofvacationList();
    await this.getStatusofvacationList();
  }
  //+++++++++ checkEdit
  public exportVacation(rowIndex: number, row: any) {
    let temp = { decisionofvacation: 1 };
// 2?
    const row1 = Object.assign(temp, row);
    this.$store.dispatch("updateCurrentObject", row1);
    this.$store.dispatch("updateCurrentComponent", "DownloadVacation");
    this.$router.replace({
      name: "load"
    });
  }
  public vacationStatus1({
    row,
    rowIndex
  }: {
    row: number;
    rowIndex: number;
  }): String {
    return this.getStatus(row, 1);
  }
  // public getleaveon2(){
  //   if (row.leave_on === undefined){
  //     return "";
  //   }
  //   return Moment(row.leave_on).format("YYYY/MM/DD")
  // }
  public getleaveon(row: any) {
    let x=JSON.parse(row.json_leaveon_leaveend)    
    let temp=""
    for(let c in x){
      console.log(x[c].leave_on)
     temp+=Moment( x[c].leave_on  ).format("DD/MM/YYYY")+ "\n"
    }
    // if (row.leave_on === undefined) {
    //   return "";
    // }
    // return Moment(row.leave_on).format("DD/MM/YYYY");
    console.log(temp)
    console.log('tempvacation')
    return temp
  }
  public getleaveend(row: any) {
    let x=JSON.parse(row.json_leaveon_leaveend)    
    let temp=""
    for(let c in x){
     temp+=Moment(x[c].leave_end ).format("DD/MM/YYYY")+ "\n" 
    }
    // if (row.leave_end === undefined) {
    //   return "";
    // }
    // return Moment(row.leave_end).format("DD/MM/YYYY");
    return temp
  }

  public getreturnon(row: any) {
    if (row.return_on === undefined) {
      return "";
    }
    return Moment(row.return_on).format("DD/MM/YYYY");
  }

  public async getvacationList() {

    let response = await postgrest.get('vacation',this.$store.getters.getToken)
    
    this.viewVacationSubmitted1 = response
    // await vacation
    //   .getAllVacations(
    //     this.$store.getters.getToken,
    //     this.$store.getters.getHost
    //   )
    //   .then(response => {
    //     response.json().then(resp => {
    //       this.viewVacationSubmitted1 = JSON.parse(JSON.stringify(resp));
          console.log("VACAY1");
          console.log(JSON.stringify(this.viewVacationSubmitted1));
          console.log('VACAY2')
          this.viewVacationSubmitted = [];
          for (const a of this.viewVacationSubmitted1) {
            var x = false;
            for (const b of this.personnelList) {
              if (a.idpersonel == b.id && b.firstname != "x") {
                console.log(a);
                console.log(b);
                console.log(b.firstname);
                console.log("xxxxxxxxxxxxxx");
                x = true;
                break;
              }
            }
            if (x == true) {
              var temp = {seen:true};
              if (a.decision == undefined) {
                a.decision = 1;
              }
              if (a.decision == 1) {
                temp = {seen:false};
                
              }

              //this.viewVacationSubmitted.push(a);
              var temp2 =a
              console.log(temp2)
              console.log("temp2")
              this.viewVacationSubmitted.push(Object.assign(temp2, temp))
              // this.viewVacationSubmitted.merge(temp)
              this.viewVacationSubmitted.sort(function(a, b) {
              var aSeen = a.seen;
              var bSeen = b.seen;
              var aDate = new Date(a.date_posted);
              var bDate = new Date(b.date_posted);

              if (aSeen == bSeen) {
                return aDate.getTime() < bDate.getTime()
                  ? -1
                  : aDate.getTime() > bDate.getTime()
                  ? 1
                  : 0;
              } else {
                return aSeen < bSeen ? -1 : 1;
              }
            });
              console.log("this.viewVacationSubmitted111111");
              console.log(this.viewVacationSubmitted);
              console.log("this.viewVacationSubmitted22222");
            }
          }
            console.log(this.viewVacationSubmitted)
          if (this.id1 != undefined && this.id1 != -1) {
            // var start = new Date(this.year1, 1, 1);
            // var end = new Date(this.year1, 12, 31);
           
            this.viewVacationSubmitted = this.viewVacationSubmitted.filter(
              word =>
                // new Date(word.leave_on) > start &&
                // new Date(word.leave_on) < end &&
                word.year_vacation == this.year1 &&
                word.idpersonel == this.id1
            );
            console.log("yyyyyyyyyyyyyyyyyyyyy");

            // this.viewVacationSubmitted = this.viewVacationSubmitted.filter(word=>this.personnelList.id == word)
          }
      //   });
      // });
    //this.fillTable();
    this.loading = false;
  }
  public async getPersonnelList() {
    // this.personnelList = await postgrest.get('personnel?select=*,companies(*),wo_spesialties(*),specialties(*)',this.$store.getters.getToken)
    this.personnelList = await postgrest.get('personnel?select=*,companies(*),wo_specialties(*),specialties(*)',this.$store.getters.getToken)
    // console.log('testforpersonnelListviewvacationsubmitted1')
    // console.log(this.personnelList)
    // console.log('testforpersonnelListviewvacationsubmitted2')

    // await personnel
    //   .getAllPersonnel(
    //     this.$store.getters.getToken,
    //     this.$store.getters.getHost
    //   )

    //   //  .then(response => {
    //   //   response.json().then(resp => {
    //   //     this.personnelList = JSON.parse(JSON.stringify(resp));
    //   //     this.personnelList.filter(word => word.active != false);
    //   //     console.log(this.personnelList);
    //   //     console.log("this.personnelList");
    //   //   });
    //   // });
    //   .then(response => {
    //     response.json().then(resp => {
    //       this.personnelList = JSON.parse(JSON.stringify(resp));
    //       console.log('testforgetpersonnelList1')
    //       console.log(JSON.stringify(this.personnelList))
    //       console.log('testforgetpersonnelList2')
    //       // for(var item in this.personnelList ){
    //       //   console.log(item.id)
    //       //   console.log("item")

    //       //           }

    //       this.personnelList = this.personnelList.filter(word =>
    //         word.active != false ? this.personnelList : (word.firstname = "x")
    //       );
    //       // console.log("this.personnelList1111111111");
    //       // console.log(this.personnelList);
    //       // console.log("this.personnelList222222222");
    //       //element != undefined ? temp == element.id : false;
    //     });
    //   });
  }
  /*
public async deleteVA(rowIndex: number, row: any) {
    await vacation
      .recycleVacation(
        this.$store.getters.getToken,
        row.id,
        this.$store.getters.getHost
      )
      .then(async r => {
        if (r.status == 400) {
          this.$message.error(r.error);
        } else {
          this.$message("Work Order Recycled");         
        }
      });
  }
*/
  public async addApproved(rowIndex: number, row: any) {
    await vacation.approvedVacation(
      this.$store.getters.getToken,
      row.id,
      this.$store.getters.getHost
    );
    this.getvacationList();
  }

  public async addRejected(rowIndex: number, row: any) {
    await vacation.rejectedVacation(
      this.$store.getters.getToken,
      row.id,
      this.$store.getters.getHost
    );
    this.getvacationList();
  }

  public async deleteVA(rowIndex: number, row: any) {
    await vacation.deleteVacation(
      this.$store.getters.getToken,
      row.id,
      this.$store.getters.getHost
    );

    this.getvacationList();

    //.then(async r => this.search());
  }

  public async open(rowIndex: number, row: any) {
    this.$confirm("This will permanently deleted. Continue?", "Warning", {
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      type: "warning"
    })
      .then(() => {
        this.$message({
          type: "success",
          message: "Delete completed"
        });
        this.deleteVA(rowIndex, row);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
  }

  public async getTypeofvacationList() {
    // let resp= await postgrest.get('type_vacation',this.$store.getters.getTokens)
    // console.log('testfoeviewvacsubmitted')
    // console.log(resp)
    // console.log('testfoeviewvacsubmitted2')
    await vacation
      .getAllType(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then(resp => {
          this.TypeofvacationList = JSON.parse(JSON.stringify(resp));
        });
      });
  }

  public async getStatusofvacationList() {
    await vacation
      .getAllStatusofvacation(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.statusofvacationList = JSON.parse(JSON.stringify(resp));
        });
      });
  }

  public sortName(a:any,b:any){
    console.log('aaaaaaaaaaaaaaaaaaaaaaaaa')
    console.log(a);
    this.nameAsc = !this.nameAsc
  if (this.nameAsc){
    
    return this.getName(a,null)>this.getName(b,null)?1:-1;
  }
    return this.getName(a,null)>this.getName(b,null)?1:-1;
  }



  public sortStatus(a:any,b:any){
    console.log('aaaaaaaaaaaaaaaaaaaaaaaaa')
    console.log(a);
    // this.nameAsc = !this.nameAsc
  // if (this.nameAsc){
    
    return this.getStatus(a,null)>this.getStatus(b,null)?1:-1;
  // }
  //   return this.getStatus(a,null)>this.getStatus(b,null)?1:-1;
  }




  public sortTypeOfvacation(a:any,b:any){
    console.log('aaaaaaaaaaaaaaaaaaaaaaaaa')
    console.log(a);
    this.nameAsc = !this.nameAsc
  if (this.nameAsc){
    
    return this.getTypeOfvacation(a,null)>this.getTypeOfvacation(b,null)?1:-1;
  }
    return this.getTypeOfvacation(a,null)>this.getTypeOfvacation(b,null)?1:-1;
  }


 public sorttotalDateRequestedDate(a:any,b:any){
    console.log("bbbbbb")
    console.log(a.total_days_req)
    console.log("bbbbbb")
    // this.dateAsc = !this.dateAsc
    console.log(Moment(a.total_days_req).format("YYYY/MM/DD"))
    console.log(Moment(b.total_days_req).format("YYYY/MM/DD"))
    console.log("----------------")
    //0
  // if(this.dateAsc){
  //   return Moment(a.leave_on).format("YYYY/MM/DD")>Moment(b.leave_on).format("YYYY/MM/DD")?1:-1;
  // }
    return a.total_days_req>b.total_days_req?1:-1;

  }



  public sortDate(a:any,b:any){
    console.log("bbbb1")
    console.log(a.leave_on)
    console.log("bbbbbbbbbbbbbbb")
    // this.dateAsc = !this.dateAsc
    console.log(Moment(a.leave_on).format("YYYY/MM/DD"))
    console.log(Moment(b.leave_on).format("YYYY/MM/DD"))
    console.log("----------------")
    //0
  // if(this.dateAsc){
  //   return Moment(a.leave_on).format("YYYY/MM/DD")>Moment(b.leave_on).format("YYYY/MM/DD")?1:-1;
  // }
    return Moment(a.leave_on).format("YYYY/MM/DD")>Moment(b.leave_on).format("YYYY/MM/DD")?1:-1;

  }


   public sortDatesortDateLeaveEnd(a:any,b:any){
    console.log("bbbbbbbbbbbbbbb")
    console.log(a.leave_end)
    console.log("bbbbbbbbbbbbbbb")
    // this.dateAsc = !this.dateAsc
    console.log(Moment(a.leave_end).format("YYYY/MM/DD"))
    console.log(Moment(b.leave_end).format("YYYY/MM/DD"))
    console.log("----------------")
    //0
  // if(this.dateAsc){
  //   return Moment(a.leave_on).format("YYYY/MM/DD")>Moment(b.leave_on).format("YYYY/MM/DD")?1:-1;
  // }
    return Moment(a.leave_end).format("YYYY/MM/DD")>Moment(b.leave_end).format("YYYY/MM/DD")?1:-1;

  }


   public sortDatesortDateReturnOn(a:any,b:any){
    console.log("bbbbbbbbbbbbbbb")
    console.log(a.return_on)
    console.log("bbbbbbbbbbbbbbb")
    // this.dateAsc = !this.dateAsc
    console.log(Moment(a.return_on).format("YYYY/MM/DD"))
    console.log(Moment(b.return_on).format("YYYY/MM/DD"))
    console.log("----------------")
    //0
  // if(this.dateAsc){
  //   return Moment(a.leave_on).format("YYYY/MM/DD")>Moment(b.leave_on).format("YYYY/MM/DD")?1:-1;
  // }
    return Moment(a.return_on).format("YYYY/MM/DD")>Moment(b.return_on).format("YYYY/MM/DD")?1:-1;

  }

  // (lemons) ? alert("please give me a lemonade") : alert("then give me a beer")
  //to row exei olo to stixio
  //element olo to stixio tou row
  public getName(row: any, column: any): String {
    let temp = row.idpersonel;
   

    let tem2 = this.personnelList.find(function(element) {
      return temp == element.id;
      // return element.id != undefined ? temp == element.id : false;
    });
   
    if (tem2.firstname != "x") {
      return tem2.firstname + " " + tem2.lastname;
    } else {
      return "x";
    }
    // return tem2 ? tem2.firstname + " " + tem2.lastname : "x";
  }

  public getStatus(row: any, column: any): String {
    let temp5 = row.decision;

    let tem6 = this.statusofvacationList.find(function(element) {
      return temp5 == element.id;
    });
    if (tem6 === undefined) return "Pending";
    return tem6.literal;
  }

  public getTypeOfvacation(row: any, column: any): String {
    console.log(JSON.stringify(row));
    let temp3 = row.type_of_vacation;

    console.log("searching for:" + temp3);
    let temp4 = this.TypeofvacationList.find(function(element) {
      return temp3 == element.id;
    });
    console.log("picked:" + temp4);

    if (temp4 === undefined) return "na";
    return temp4.type_of_vacation;
  }

  // public Edit(row: any, column: any){  }

  public Edit(rowIndex: number, row: any) {
    //row.vacation = JSON.stringify(row.vacation);
console.log("this is the row of vacaton------>"+JSON.stringify(row))
console.log("this is the  rowIndex of vacation--->"+rowIndex)

    this.$store.dispatch("updateCurrentObject", row );
    this.$store.dispatch("updateCurrentComponent", "AddNewVacation");
    this.$router.replace({ name: "load" });
  }

  /* prepi na kane kai delete kai apo to object... na to prosthesw 
     updateCurrentVacation ?? 
    public getLeaveon(row: any, column: any){

     return Moment(date).format("DD/MM/YYYY");
    }
*/

  /*
    public async getName(row: any, column: any): String {

      return row.personnel.lastname + " " + row.personnel.firstname;
    }   
      */
  /*    
public handleClick(rowIndex: number, row: any) {
    row.personnel = JSON.stringify(row.personnel);
    this.$store.dispatch("updateCurrentObject", row);
    this.$store.dispatch("setCurrentId", row.id);
    this.$store.dispatch("updateCurrentComponent", "AddWorkOrder");
    this.$router.replace({
      name: "load"
    });
  }

public checkEdit(row: any) {
    if (this.userlevel < 2 || row.date_closed == undefined) {
      return true;
    }
    if (
      new Date(row.date_closed).getTime() + 1000 * 60 * 60 * 24 * 11 >=
      new Date().getTime()
    ) {
      return true;
    }
    return false;
  }
*/
}
</script>

<style>
.el-table .Pending {
  background: rgb(236, 255, 149);
}

.el-table .Completed {
  background: #ffffff;
}

.el-table .Cancelled {
  background: rgb(255, 186, 186);
}
</style><style scoped>
.container {
  border: 2px solid rgb(170, 238, 238);
  border-radius: 10px;
  background-color: rgb(248, 247, 247);
  padding: 5px 10px 5px 10px;
}

.personnel {
  background-color: rgb(230, 242, 255);
  font-weight: normal !important;
  padding-left: 10px;
  padding-right: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: gray;
}

.personnelHead {
  background-color: rgb(255, 242, 240);
  font-weight: normal !important;
  padding-left: 10px;
  padding-right: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: gray;
}

u {
  text-decoration: underline;
}

.hours {
  padding-top: 0px;
  padding-bottom: 0px;
  background-color: rgb(230, 242, 255);
  padding-right: 10px;
}
</style>
